"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * @function useKeyPress - validates the key pressed
 * @param {string | number} searchKey - can be the character pressed or its keyCode
 * @param {callback} handler
 * @param {element} element - the element where the listener is attached
 * @returns {callback}
 */
function useKeyPress(searchKey, handler, element = null) {
    react_1.useEffect(() => {
        const listener = ({ keyCode, key }) => {
            if (typeof searchKey === 'string')
                return key === searchKey && handler();
            return keyCode === searchKey && handler();
        };
        const elementToListen = element || window;
        elementToListen.addEventListener('keydown', listener);
        return () => {
            elementToListen.removeEventListener('keydown', listener);
        };
    }, [handler, searchKey, element]);
}
exports.default = useKeyPress;
//# sourceMappingURL=index.js.map